var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSearchDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#093F46",
    d: "M9.94 16.22a6 6 0 01-4.43-1.82 6.03 6.03 0 01-1.82-4.43c0-1.74.6-3.21 1.82-4.43a6.03 6.03 0 014.43-1.82 6 6 0 014.42 1.82 6.03 6.03 0 011.83 4.43c0 1.73-.61 3.21-1.83 4.43a6.03 6.03 0 01-4.42 1.82zM21.14 22a.8.8 0 00.57-.2c.41-.39.43-.8.05-1.26l-5.57-5.62a7.66 7.66 0 001.71-4.95c0-2.19-.77-4.06-2.31-5.63A7.64 7.64 0 009.94 2c-2.23 0-4.11.78-5.66 2.34a7.71 7.71 0 00-2.31 5.63 7.7 7.7 0 002.31 5.62 7.65 7.65 0 005.66 2.35 7.8 7.8 0 005.05-1.77l5.52 5.57c.17.17.38.26.62.26z"
  })));
}

export default SvgIconSearchDark;